export default "__VITE_ASSET__DkGLezcV__"